import dayjs, { Dayjs } from "dayjs";

/** A date of birth is a calendar date, never a UTC instant. */
export function calendarDate(value: Dayjs | null): string {
  if (value === null) return "";
  return value.isValid() ? value.format("YYYY-MM-DD") : "Invalid date";
}

export function validateCalendarDate(
  value: string | undefined,
  required = false,
): string | undefined {
  if (!value) return required ? "Date of birth is required" : undefined;
  return /^\d{4}-\d{2}-\d{2}$/.test(value) &&
    dayjs(value).isValid() &&
    dayjs(value).format("YYYY-MM-DD") === value
    ? undefined
    : "Enter a valid date of birth";
}
